import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

let firebaseConfig;
// console.log("FireBase Environment Name:", process.env.REACT_APP_ENVIRONMENT_NAME);

// Wybierz konfigurację na podstawie REACT_APP_ENVIRONMENT_NAME
if (process.env.REACT_APP_ENVIRONMENT_NAME === "development") {
  firebaseConfig = require("./firebase-dev").default;
} else if (process.env.REACT_APP_ENVIRONMENT_NAME === "staging") {
  firebaseConfig = require("./firebase-stage").default;
} else if (process.env.REACT_APP_ENVIRONMENT_NAME === "production") {
  firebaseConfig = require("./firebase-prod").default;
} else {
  throw new Error("No Firebase configuration for the current environment.");
}

// Maskowanie identyfikatora projektu Firebase
// const maskProjectId = (projectId) => {
//   const [name, ...suffix] = projectId.split("-");
//   const maskedName = name.slice(-2).padStart(name.length, "*");
//   return `${maskedName}${suffix.length > 0 ? `-${suffix.join("-")}` : ""}`;
// };
// console.log("Firebase Project ID:", maskProjectId(firebaseConfig.projectId));

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db }; // Eksport auth i db
export default app;  // Opcjonalnie eksport domyślny